import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { withTranslation } from "react-i18next";
import MyProfile from "../myProfile/myProfile";
import QuickBillSummary from "../billingPayment/QuickBillSummary";
import ViewCases from "../cases/ViewCases";
import ViewCaseDetails from "../cases/ViewCaseDetails";
import Navigation from "./Navigation";
import { changeLanguage } from "../../util/userLanguageUtils";
import { LeftSection, RightSection } from "../../constants/common/StyledGlobalConstants";
import Contract from "../myContract/Contract";
import { TechnicianAppointments } from "../technicianAppointments/TechnicianAppointments";
import ViewAppointmentDetails from "../technicianAppointments/ViewAppointmentDetails";
import { DEVICE_BREAKPOINTS } from "../../constants/appConstants";

const { DESKTOP } = DEVICE_BREAKPOINTS;

class MyAccount extends Component {
  constructor(props) {
    super(props);
    this.state = {
      userLanguage: "",
      nameSpace: "",
    };
  }

  componentDidMount() {
    const language = this.props.userLanguage.replace(/-/g, "");
    const nameSpace = changeLanguage(language, "myAccount");
    
    this.setState({ 
      userLanguage: language, 
      nameSpace: nameSpace 
    }, () => {
      this.props.i18n.changeLanguage(this.state.userLanguage);
    });
    
    window.scrollTo(0, 0);
  }

  getMarginTop() {
    if (
      (this.props.cases === 1 && this.props.viewDetail === 1) ||
      (this.props.technicianAppointments === 4 && this.props.viewAppointmentDetails === 1)
    )
      return "1rem";
    else return "3rem";
  }
  render() {
    return (
      <>
        {this.props.windowSize.width >= DESKTOP ? (
          <LeftSection aria-orientation="vertical">
            <Navigation {...this.props} />
          </LeftSection>
        ) : (
          <Navigation {...this.props} />
        )}
        <RightSection marginTop={this.getMarginTop()}>
          {this.props.billing === 0 && (
            <QuickBillSummary
              {...this.props}
              invoiceId={this.props.invoiceId}
              title={this.props.t("Customer Portal - Billing and payment", { ns: `${this.state.nameSpace}` })}
            />
          )}
          {this.props.billing === 2 && <MyProfile {...this.props} />}

          {this.props.cases === 1 && (
            <>
              {this.props.viewDetail === 0 && (
                <ViewCases title={this.props.t("Customer Portal - Support cases", { ns: `${this.state.nameSpace}` })} />
              )}
              {this.props.viewDetail === 1 && (
                  <ViewCaseDetails {...this.props} title={this.props.t("Customer Portal - View case details", { ns: `${this.state.nameSpace}` })} />
              )}
            </>
          )}
          {this.props.myContract === 3 && (
              <Contract {...this.props} title={"Customer Portal - Contracts and subscriptions"} />
          )}
          {this.props.technicianAppointments === 4 && (
            <>
              {this.props.transferRemoveDevice === 0 && (
                <TechnicianAppointments {...this.props} title={"Customer Portal - Technician appointments"} serviceType={0} />
              )}
              {this.props.transferRemoveDevice === 1 && (
                <TechnicianAppointments {...this.props} title={"Customer Portal - Technician appointments - Transfer Device"} serviceType={1} />
              )}
              {this.props.transferRemoveDevice === 2 && (
                <TechnicianAppointments {...this.props} title={"Customer Portal - Technician appointments - Remove Device"} serviceType={2} />
              )}
              {this.props.viewAppointmentDetails === 1 && (
                <ViewAppointmentDetails
                  {...this.props}
                  title={"Customer Portal - Technician appointments - Appointment Details"}
                  serviceType={0}
                ></ViewAppointmentDetails>
              )}
              {this.props.viewAppointmentDetails === 2 && (
                <ViewAppointmentDetails {...this.props} title={"Customer Portal - Technician appointments - Reschedule"} serviceType={0} />
              )}
            </>
          )}
          {/* Footer will not be enabled, if VEPS page is displayed */}
          {this.props.isFooterEnabled && <footer className="footerStyle"></footer>}
        </RightSection>
      </>
    );
  }
}

MyAccount.propTypes = {
  cases: PropTypes.number,
  viewDetail: PropTypes.number,
  technicianAppointments: PropTypes.number,
  viewAppointmentDetails: PropTypes.number,
  windowSize: PropTypes.object,
  billing: PropTypes.number,
  invoiceId: PropTypes.string,
  t: PropTypes.func,
  i18n: PropTypes.object,
  userLanguage: PropTypes.string,
  myContract: PropTypes.number,
  transferRemoveDevice: PropTypes.number,
  isFooterEnabled: PropTypes.bool,
};

export default withTranslation([
  "accountTranslation",
  "billingTranslation",
  "headerTranslation",
  "navigationTranslation",
  "loginTranslation",
  "casesTranslation",
  "leftNavigationTranslation",
])(
  connect((state) => {
    return {
      accountProfilePermission: state.ACCOUNT.accountProfilePermission,
      viewInvoicesPermission: state.ACCOUNT.viewInvoicesPermission,
      managePaymentsPermission: state.ACCOUNT.managePaymentsPermission,
      viewFinancialCasesPermission: state.ACCOUNT.viewFinancialCasesPermission,
      viewallotherCasesPermission: state.ACCOUNT.viewallotherCasesPermission,
      userLanguage: state.ACCOUNT.userLanguage,
      windowSize: state.ACCOUNT.windowSize,
      isFooterEnabled: state.BILLING.isFooterEnabled,
      accountFinancialStatus: state.ACCOUNT.accountFinancialStatus,
      paymentStatus: state.ACCOUNT.paymentStatus,
      regionId: state.ACCOUNT.regionId,
    };
  })(MyAccount)
);
